export const parsePxToNumber = (value) => {
  const normalized = String(value ?? "")
    .replace("px", "")
    .trim();
  if (!normalized) {
    return null;
  }
  const parsed = parseInt(normalized, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};
